<template>
    <div class="chkd">
        <!-- <p></p> -->
        <div class="imgDiv">
            <img src="../../assets/chkd/img/logo.gif" alt />
        </div>
        <div class="chkd_top">
            <popup ref="popup1" :coluMns="columns1" :value="'主要主题'" :defaultIndex="0"></popup>
            <popup ref="popup2" :coluMns="columns2" :value="'题名/关键词/摘要'" :defaultIndex="0"></popup>
            <popup ref="popup3" :coluMns="columns2" :value="'题名'" :defaultIndex="1"></popup>
            <popup ref="popup4" :coluMns="columns2" :value="'关键词'" :defaultIndex="2"></popup>
            <!-- <popup ref="popup5" :coluMns="columns2" :value="'摘要'" :defaultIndex="3"></popup> -->
        </div>
        <div class="chkd_bottom">
            <van-field v-model="au" label="作者姓名" placeholder="请输入作者姓名" />
            <van-field v-model="aff" label="作者单位" placeholder="请输入作者单位" />
            <div style="background: #fff;line-height:46px">
                <div class="label">
                    <span>发表时间</span>
                </div>
                <van-field
                    readonly
                    clickable
                    :value="yearStart"
                    placeholder="开始时间"
                    @click="year1 = true"
                    style="width:31%;float:left;padding-left:6px;"
                />
                <van-popup v-model="year1" position="bottom">
                    <van-datetime-picker
                        @cancel="year1 = false"
                        v-model="currentDate"
                        type="date"
                        :min-date="minStaet"
                        :max-date="maxStaet"
                        @confirm="staetConfirm"
                    />
                </van-popup>
                <span style="float:left;">至</span>
                <van-field readonly clickable :value="yearEnd" placeholder="结束时间" @click="year2 = true" style="width:31%;float:left" />
                <van-popup v-model="year2" position="bottom">
                    <van-datetime-picker
                        @cancel="year2 = false"
                        v-model="currentDate"
                        type="date"
                        :min-date="minEnd"
                        :max-date="maxEnd"
                        @confirm="endConfirm"
                    />
                </van-popup>
            </div>
            <van-field readonly clickable label="更新时间" :value="updateDate" placeholder="不限" @click="updateDateShow = true" />
            <van-popup v-model="updateDateShow" position="bottom">
                <van-picker show-toolbar :columns="updateDateCon" @cancel="updateDateShow = false" @confirm="upOnConfirm" />
            </van-popup>
            <van-field v-model="source" label="文献来源" placeholder="输入期刊名称，ISSN，CN均可" />
            <van-field v-model="fund" label="文献基金" placeholder="文献基金" />
            <van-field readonly clickable label="文献类型" :value="dtValue" placeholder="期刊类型" @click="dtShowPicker = true" />
            <van-popup v-model="dtShowPicker" position="bottom">
                <van-picker show-toolbar :columns="dtColumns" @cancel="dtShowPicker = false" placeholder="请选择文献类型" @confirm="dtOnConfirm" />
            </van-popup>
        </div>
        <!-- <van-button type="info" to="/chkdList">检索</van-button> -->
        <van-button type="info" @click="retrieval()">检索</van-button>
    </div>
</template>
<script>
// import { Toast } from 'vant'
import popup from "../../components/popup";
export default {
    data() {
        return {
            columns1: ["主要主题", "主题", "分类"],
            columns2: ["题名/关键词/摘要", "题名", "关键词", "摘要", "ABSTRACT", "全文"],
            dtColumns: ["期刊类型"],
            au: "",
            aff: "",
            source: "",
            fund: "",
            yearStart: "",
            yearEnd: "",
            year1: false,
            year2: false,
            dtShowPicker: false,
            maxStaet: new Date(),
            minStaet: new Date(1900, 0, 1),
            minEnd: new Date(),
            maxEnd: new Date(),
            currentDate: new Date(),
            dtValue: "",
            updateDateShow: false,
            updateDate: "",
            updateDateCon: ["不限", "最近一周", "最近一月", "最近半年", "最近一年", "今年迄今", "上一年度"]
        };
    },
    components: {
        popup
    },
    mounted() {
        this.$store.dispatch("actionsHead", { type: false, title: "中国医院知识总库(CHKD)", iconType: false });
    },
    methods: {
        staetConfirm(value) {
            this.yearStart = value.getFullYear() + "/" + (value.getMonth() + 1) + "/" + value.getDate();
            this.year1 = false;
            this.minEnd = new Date(value.getFullYear(), value.getMonth(), value.getDate());
        },
        endConfirm(value) {
            this.yearEnd = value.getFullYear() + "/" + (value.getMonth() + 1) + "/" + value.getDate();
            this.year2 = false;
            this.maxStaet = new Date(value.getFullYear(), value.getMonth(), value.getDate());
        },
        dtOnConfirm(value) {
            this.dtValue = value;
            this.dtShowPicker = false;
        },
        upOnConfirm(value) {
            this.updateDate = value;
            this.updateDateShow = false;
        },
        retrieval() {
            var data = {
                input1: this.$refs.popup1.input,
                sel1: this.sel1(this.$refs.popup1.value),
                input2: this.$refs.popup2.input,
                sel2: this.sel2(this.$refs.popup2.value),
                input3: this.$refs.popup3.input,
                sel3: this.sel2(this.$refs.popup3.value),
                input4: this.$refs.popup4.input,
                sel4: this.sel2(this.$refs.popup4.value),
                // input5: this.$refs.popup5.input,
                // sel5: this.sel2(this.$refs.popup5.value),
                au: this.au,
                aff: this.aff,
                yearStart: this.yearStart,
                yearEnd: this.yearEnd,
                page: 1,
                updateDate: this.updateDate,
                source: this.source,
                fund: this.fund,
                dt: this.dtValue
            };
            this.$router.push({
                path: "/chkdList",
                query: data
            });
        },
        sel1(selInp) {
            if (selInp == "主要主题") {
                return "主要主题词";
            } else if (selInp == "主题") {
                return "主题词";
            } else if (selInp == "分类") {
                return "分类号";
            }
        },
        sel2(selInp) {
            if (selInp == "题名/关键词/摘要") {
                return "主题";
            } else if (selInp == "关键词") {
                return "关键词,复合关键词";
            } else if (selInp == "题名") {
                return "题名";
            } else if (selInp == "摘要") {
                return "摘要";
            } else if (selInp == "ABSTRACT") {
                return "ABSTRACT";
            } else if (selInp == "全文") {
                return "全文,章节全文";
            }
        }
    }
};
</script>
<style lang="less">
.chkd {
    background: #fff;
    .imgDiv {
        background: #fff;
        border-bottom: 1px solid #e3e3e3;
        text-align: center;
        margin: 0.8rem 0;
        img {
            width: 35%;
            margin: 1rem 0;
        }
    }
    .chkd_top {
        > div {
            overflow: hidden;
            margin-bottom: 0.5rem;
            .van-field {
                width: 68%;
                float: left;
                .van-cell__value {
                    border-bottom: 1px solid #e3e3e3;
                    padding: 0 0 0 0.5rem;
                }
            }
            .van-cell--clickable {
                width: 30%;
                background: url("../../publics/image/07.png") right center no-repeat;
                background-size: 0.5rem;
                .van-cell__value {
                    border: 0;
                }
            }
        }
    }
    .chkd_bottom {
        overflow: hidden;
        line-height: 1.5rem;
        background: #f3f3f3;
        padding-top: 0.8rem;
        > div {
            overflow: hidden;
        }
        span {
            font-size: 14px;
        }
        .label {
            float: left;
            font-size: 14px;
            padding-left: 16px;
            width: 30%;
            span {
                padding: 0 0 0 0.5rem;
                font-size: 17px;
            }
        }
        .van-cell--clickable {
            .van-field__control {
                background: url("../../publics/image/07.png") 95% center no-repeat;
                background-size: 0.4rem;
                border-bottom: 1px solid #dadada;
                padding: 0 0.5rem;
                border-radius: 2px;
            }
        }
        .van-cell__title {
            width: 30%;
            span {
                padding: 0 0 0 0.5rem;
                font-size: 17px;
            }
        }
        .van-field__control {
            border-bottom: 1px solid #e3e3e3;
            border-radius: 0;
            width: 97%;
        }
    }
    > button {
        width: 85%;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        margin: 2rem 0;
    }
    .van-field__control {
        font-size: 17px;
    }
}
</style>
